// BrainStatus — mostra, antes de disparar, qual cérebro está disponível:
// Cloud (sempre via Worker) e se o Ollama/LM Studio local está online.
// `capabilities` vem de GET /api/dispatch/runner/capabilities.

import { CheckCircle } from 'lucide-react';

export default function BrainStatus({ capabilities }) {
  const caps = capabilities || {};
  const cloudCount = Array.isArray(caps.cloudModels) ? caps.cloudModels.length : 0;
  const ollamaOnline = !!caps.ollama?.online;
  const lmOnline = !!caps.lmstudio?.online;

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-apolo-textTertiary" aria-label="Status do cérebro">
      <span className="inline-flex items-center gap-1">
        Cloud
        <CheckCircle size={12} aria-hidden="true" />
        {cloudCount > 0 ? `(${cloudCount})` : null}
      </span>
      <span>Ollama: {ollamaOnline ? 'online' : 'offline'}</span>
      {lmOnline && <span>LM Studio: online</span>}
    </div>
  );
}
